<template>
  <div
    :style="{
      background: 'white',
      padding: '24px',
      minHeight: '380px',
      height: '100%',
    }"
  >
    <!-- <div :style="{ background: 'white', padding: '24px', minHeight: '380px' }">
        <Content/>
      </div> -->
    Exp_Hole:
    <a-spin :spinning="loading">
      <a-tree-select
        v-model="Holevalue"
        style="width: 30%"
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
        :tree-data="treeHoleData"
        placeholder="Please select"
        tree-checkable
        tree-default-expand-all
        show-search
        allowClear
        @search="handleSearchHoleByName"
      >
        <span
          v-if="key === '0-0-1'"
          slot="title"
          slot-scope="{ key, Holevalue }"
          style="color: #08c"
        >
          {{ Holevalue }}
        </span>
        <span
          v-elif="disabled === true"
          slot="title"
          slot-scope="{ disabled, Holevalue }"
          style="color: #08c"
          disabled
        >
          {{ Holevalue }}
        </span>
      </a-tree-select></a-spin
    >

    <div class="myicon"></div>
    <br /><br />

    <ageContent :hole="Holevalue" />
    <!-- <earth/> -->
  </div>
</template>

<script>
import { getAllAgeModelHole } from '@/api';
import ageContent from '@/components/ageContent/info.vue';
const treeHoleData = [];

export default {
  name: 'ageName',
  components: { ageContent },
  data() {
    return {
      Holevalue: [],
      treeHoleData,
      age: 0,
      depth: 0,
      noHole: undefined,
      value: 'Bchron',
      str: '',
      loading: false,
    };
  },
  mounted() {
    // this.$router.push({
    //   name: 'info',
    //   query: { Holevalue: '1000A', way: 'treelist', method: this.value },
    // });
    this.loading = true;
    getAllAgeModelHole().then((res) => {
      res = res.filter((x) => !!x == true || x == 0);
      // res.sort(function (a, b) {
      //   console.log(a, b);
      //   // a = a.replace(/[^\d]/g, ' ');
      //   // b = b.replace(/[^\d]/g, ' ');
      //   // return b - a;
      //   // 提取数字部分
      //   // const getNumericPart = (str) => parseInt(str.match(/\d+/)[0], 10);

      //   // // 检查是否以 'C' 开头
      //   // const isCStart = (str) => str.startsWith('C') || str.startsWith('M');

      //   // // a 和 b 是否以 'C' 开头
      //   // const aIsCStart = isCStart(a);
      //   // const bIsCStart = isCStart(b);

      //   // // 如果 a 和 b 都以 'C' 开头，则按数字从大到小排序
      //   // if (aIsCStart && bIsCStart) {
      //   //   return getNumericPart(b) - getNumericPart(a);
      //   // }

      //   // // 如果 a 以 'C' 开头，b 不以 'C' 开头，则 a 优先
      //   // if (aIsCStart) return -1;

      //   // // 如果 b 以 'C' 开头，a 不以 'C' 开头，则 b 优先
      //   // if (bIsCStart) return 1;

      //   // // 如果都不以 'C' 开头，则按数字从大到小排序
      //   // return getNumericPart(b) - getNumericPart(a);
      //   const [legA, holeA] = a.split('_');
      //   const [legB, holeB] = b.split('_');

      //   // 排序逻辑
      //   // 1. 根据 leg 排序
      //   const legComparison = legA.localeCompare(legB);
      //   if (legComparison !== 0) return legComparison;

      //   // 2. 根据 hole 排序（去掉后面的字符）
      //   const holeBaseA = holeA.replace(/[A-Z]/g, '');
      //   const holeBaseB = holeB.replace(/[A-Z]/g, '');
      //   const holeComparison = holeBaseA.localeCompare(holeBaseB);
      //   if (holeComparison !== 0) return holeComparison;

      //   // 3. 相同 hole 的情况下，根据后面的字符排序
      //   const suffixA = holeA.slice(holeBaseA.length);
      //   const suffixB = holeB.slice(holeBaseB.length);
      //   const suffixComparison = suffixA.localeCompare(suffixB);

      //   // 4. 相同后缀的情况下，优先级较低的值放后
      //   if (suffixA === '') return 1; // hole 中没有后面字符的优先级较低
      //   if (suffixB === '') return -1;

      //   return suffixComparison;
      // });
      console.log(res);
      res.map((item) => {
        this.treeHoleData.push({ title: item, value: item });
      });
      this.loading = false;
    });
  },
  // watch: {
  //   Holevalue(value) {
  //     if (value.length === 0) return (this.noHole = true);

  //     this.noHole = false;

  //     this.$router.push({
  //       name: 'treelist',
  //       query: { Holevalue: value, way: 'treelist', method: this.value },
  //     });
  //   },
  // },
  methods: {
    showEarth() {
      this.$router.push({
        name: 'earth',
        query: {
          type: 'age',
        },
        // query:{
        //     id:m.id,
        //     title:m.title
        // }
      });
    },
    handleSearchHoleByName() {},
    showList() {
      this.$router.push({
        name: 'select',
        // query:{
        //     id:m.id,
        //     title:m.title
        // }
      });
    },

    onClose() {
      console.log('s');
    },
    onChange(e) {
      if (this.Holevalue == undefined || this.Holevalue.length == 0)
        return (this.noHole = true);
      else this.$bus.$emit('updateMethod', e.target.value);
      // this.$router.push({name:'treelist',query:{Holevalue:this.Holevalue,way:'treelist',method:e.target.value}})
      // console.log('radio checked', e.target.value);
    },
  },
};
</script>

<style scoped>
.earth {
  margin: 0 60px;
  justify-content: center;
  justify-items: center;
}
.earth :hover,
.list :hover {
  cursor: pointer;
}
.myicon {
  display: inline-block;
}
.age-depth {
  font-size: larger;
  margin-top: 20px;
  font-weight: bold;
}
.radio-group {
  display: inline-block;
  margin-left: 30px;
}
.alert {
  margin-top: 20px;
  border-radius: 2px;
  border: 1px solid red;
  padding: 20px;
  background-color: hsl(350, 60%, 98%);
}
</style>
